// Only display message strings. Error envelopes and HTML responses are not UI text.
export function getApiErrorMessage(body, fallback) {
    const candidates = [body?.error?.message, body?.description, body?.message, body?.error];
    return candidates.find(value => typeof value === 'string' && value.trim()) || fallback;
}

export async function getResponseErrorMessage(response, fallback) {
    try {
        return getApiErrorMessage(await response.json(), fallback);
    } catch {
        return fallback;
    }
}

export function getRequestErrorMessage(error, fallback) {
    if (error?.response) return getApiErrorMessage(error.response.data, fallback);
    return typeof error?.message === 'string' && error.message.trim() ? error.message : fallback;
}
